import React, { useState } from "react";
import { Button, Modal, CloseButton } from "react-bootstrap";
import iconLoadingGreen from "../assets/images/icon-loading.svg";
import iconLoadingBlack from "../assets/images/icon-loading.svg";
import "./TransactionSubmitted.css";

function TransactionSubmitted() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button
            className="reject swap--button"
            variant="primary"
            size="lg"
            onClick={handleShow}
          >
            Reject
          </Button>
        <Modal
          show={show}
          onHide={handleClose}
          className="transaction"
        >
        <Modal.Header>
            <CloseButton variant="white" onClick={handleClose} />
        </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center align-items-center">
              <img src={iconLoadingGreen} alt="" className="loadingGreen"/>
              <img src={iconLoadingBlack} alt="" className="loadingBlack" />
            </div>
            <div className="d-flex text-center text-white justify-content-center flex-column mt-5">
              <h1 className="text-center">Waiting for confirmation</h1>
              <div className="confirmation-text">
                  <p>Supplying 0.001588 CAO and 1.23224 AMPL</p>
                  <p>Confirm this transaction in your wallet</p>
                </div>
            </div>
          </Modal.Body>
        </Modal>
      
    </>
  );
}

export default TransactionSubmitted;
